import React from "react";
import { useTranslation } from "react-i18next";

// One consistent empty state for every panel, replacing the mixed
// "No Data Found" / "No data available" strings.
const ChartState = ({ loading }) => {
  const { t } = useTranslation();
  if (loading) return null;

  return (
    <div className="no-report-render">
      <div className="desc-space">
        <h4 className="text-center">{t("No data for this period")}</h4>
      </div>
    </div>
  );
};

export default ChartState;
